import { BreadCrumbs } from './computeBreadCrumbs'

interface ComputeTermPageBreadCrumbs {
  (props: { term }): { breadCrumbs: BreadCrumbs; selectedTitle: string }
}

const computeTermPageBreadCrumbs: ComputeTermPageBreadCrumbs = ({ term }) => {
  return {
    breadCrumbs: [],
    selectedTitle: term.title || ''
  }
}

export default computeTermPageBreadCrumbs
